function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Hotel Bell Icon");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "hotel-bell-Icon/Global/Business_Lines/Hospitality",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "hotel-bell-Group-14",
  transform: "translate(1.000000, 5.000000)",
  stroke: "currentcolor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.8666667,24.2666667 C15.3293699,21.3035488 17.7745455,18.8659147 20.8,17.3333333",
  id: "hotel-bell-Stroke-277"
}), /*#__PURE__*/React.createElement("line", {
  x1: 19.9333333,
  y1: 3.03333333,
  x2: 32.0666667,
  y2: 3.03333333,
  id: "hotel-bell-Stroke-281"
}), /*#__PURE__*/React.createElement("line", {
  x1: 25.5666667,
  y1: 7.94456479,
  x2: 25.5666667,
  y2: 3.32210188,
  id: "hotel-bell-Stroke-283"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "hotel-bell-Stroke-285",
  points: "51.0640436 36.2160112 51.1333333 40.9173221 0.866666667 40.9173221 0.935956448 36.2160112"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.2666667,32.0666667 C47.9265533,32.0666667 47.120955,28.269329 46.9376241,27.1513266 C45.2938157,17.157916 39.8379583,9.53333333 26.1207516,9.53333333 L25.8792484,9.53333333 C12.1611603,9.53333333 6.70530292,17.157916 5.0623759,27.1513266 C4.87904499,28.269329 3.50935154,32.0666667 1.73333333,32.0666667",
  id: "hotel-bell-Stroke-287"
}), /*#__PURE__*/React.createElement("line", {
  x1: 0.481481481,
  y1: 32.0666667,
  x2: 51.5185185,
  y2: 32.0666667,
  id: "hotel-bell-Stroke-279"
})));

var SvgHotelBell = function SvgHotelBell(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 54 54",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHotelBell, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hotel-bell.662f273d.svg";
export { ForwardRef as ReactComponent };